import { createRedux } from 'src/firebase';
import { FeaturedAds } from 'src/store';

const {
  actions,
  actionTypes,
  collectionReducer: featuredAdsReducer,
  docReducer: featuredAdsDetailReducer,
} = createRedux<FeaturedAds>('featuredAds');

export {
  actions,
  actionTypes,
  featuredAdsReducer,
  featuredAdsDetailReducer,
};



// WEBPACK FOOTER //
// ./src/featuredAds/redux.ts